import { action } from 'satcheljs/lib/legacy';
import { lazyBootstrapEventToCalendarAssociation } from 'mini-event-to-calendar-association';
import { loadFolders } from 'mini-mail-folder-actions';
import { SessionData } from 'owa-service/lib/types/SessionData';
import { stashSessionDataResponses } from '../sessionDataResponseStash';
import { addNewMiddleWare } from 'owa-middleware';
import { getSatchelLegacyMiddlewaresForMail } from '../getSatchelLegacyMiddlewaresForMail';
import { getSatchelMiddlewaresForMail } from '../getSatchelMiddlewaresForMail';

/**
 * Function which loads the initial Mail Folders in the store
 */
export default action('initializeMailModuleState')(function initializeMailModuleState(
    sessionData: SessionData
): void {
    stashSessionDataResponses(sessionData);
    addNewMiddleWare(getSatchelMiddlewaresForMail(), getSatchelLegacyMiddlewaresForMail());
    loadFolders();
    lazyBootstrapEventToCalendarAssociation.importAndExecute();
});
